import { LayerDefinition } from './types';

export const alpenglowDefinition: LayerDefinition = {
  id: 'alpenglow',
  name: 'Golden Hour / Alpenglow',
  category: 'forecast',
  categoryLabel: 'Forecast Quality Scoring',
  icon: '🏔️🌅',
  description: 'Dual-mode alpine alpenglow (topographic prominence & solar aspect hillshading) and landscape golden hour forecast.',
  sourceModels: ['hrrr', 'rrfs', 'rdps', 'gfs', 'ecmwf'],
  outputModels: ['gw_v2_blend_50', 'gw_v2_hrrr', 'gw_v2_rrfs', 'gw_v2_rdps', 'gw_v2_gfs', 'gw_v2_ecmwf', 'gw_nowcast'],
  config: {
    defaultModel: 'gw_v2_blend_50',
    defaultOpacity: 0.8
  }
};

export default alpenglowDefinition;
